// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"acc56d6e","453":"546b8a7f"}[chunkId] + ".chunk.js";
};